import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLang } from "../i18n/LanguageContext";
import { toAbsUrl } from "../data/ApartmentDataContext";
import { X } from "lucide-react";
import { Seo } from "../components/Seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Gallery() {
  const { t } = useLang();
  const [photos, setPhotos] = useState([]);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    axios.get(`${API}/gallery`).then(({ data }) => setPhotos(data || [])).catch(() => setPhotos([]));
  }, []);

  return (
    <div data-testid="gallery-page" className="pt-28">
      <Seo
        title="Galerija — Sakurų namai Marijampolėje"
        description="Sakurų namų vizualizacijos ir vaizdai — nauji A++ butai Marijampolėje prie Pašešupio parko."
        path="/galerija"
      />
      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <p className="text-xs uppercase tracking-[0.3em] text-gold mb-4">{t("gallery.subtitle")}</p>
        <h1 className="font-serif text-5xl sm:text-6xl font-light text-cream">{t("gallery.title")}</h1>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-8 pb-24">
        {photos.length === 0 ? (
          <p className="text-cream/40 text-center py-24" data-testid="gallery-empty">{t("gallery.empty")}</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {photos.map((g, i) => {
              const src = toAbsUrl(g.url);
              return (
                <button
                  key={g.id}
                  data-testid={`gallery-item-${i}`}
                  onClick={() => setLightbox(src)}
                  className={`group relative rounded-lg overflow-hidden ${i % 5 === 0 ? "sm:col-span-2" : ""}`}
                >
                  <img
                    src={src}
                    alt=""
                    loading="lazy"
                    className={`w-full object-cover ${i % 5 === 0 ? "h-80" : "h-64"} group-hover:scale-105 transition-transform duration-700`}
                  />
                  <span className="absolute inset-0 bg-charcoal/0 group-hover:bg-charcoal/20 transition-colors" />
                </button>
              );
            })}
          </div>
        )}
      </section>

      {lightbox && (
        <div className="fixed inset-0 z-[60] bg-charcoal/95 flex items-center justify-center p-6" onClick={() => setLightbox(null)} data-testid="gallery-lightbox">
          <button className="absolute top-6 right-6 text-cream/70 hover:text-gold" data-testid="gallery-lightbox-close"><X size={28} /></button>
          <img src={lightbox} alt="" className="max-h-[85vh] max-w-full object-contain rounded-lg" />
        </div>
      )}
    </div>
  );
}
